const initFeaturedProducts = () => {
  document.querySelectorAll('[data-featured-products]').forEach(container => {
    const tabs = container.querySelectorAll('[data-collection-tab]');
    const panels = container.querySelectorAll('[data-collection-panel]');
    const seeAll = container.querySelector('[data-collection-see-all]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-collection-tab');

        tabs.forEach(t => {
          t.setAttribute('aria-selected', 'false');
          t.classList.replace('bg-black', 'bg-transparent');
          t.classList.replace('text-white', 'text-black');
          t.classList.replace('border-black', 'border-transparent');
        });

        tab.setAttribute('aria-selected', 'true');
        tab.classList.replace('bg-transparent', 'bg-black');
        tab.classList.replace('text-black', 'text-white');
        tab.classList.replace('border-transparent', 'border-black');

        panels.forEach(panel => {
          panel.classList.toggle('hidden', panel.getAttribute('data-collection-panel') !== id);
        });

        if (seeAll) seeAll.href = tab.getAttribute('data-collection-url');
      });
    });
  });
};

export default initFeaturedProducts;
